import React,  { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";


import { Checkbox, FormControlLabel, TextField,MenuItem } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { editUser
  ,getRolesByAccount , getAccounts, getMyProfile,getMyAccounts,getLocations
} from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";
import InputLabel from '@material-ui/core/InputLabel';

import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

function EditUser(props) {
  
  console.log('Loaded CreateUser',props);
  
  const { intl } = props;
   
   let isLoaded = false;


  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

 // const [user,setUser] =useState({});

  
  const [rolesData,setRoles] =useState({roles:[],isLoading:false});

  const [locations,setLocations] = useState([]);

  const [editUserData,setEditUser] =useState({editUser:props.location.data.user});
  
  React.useEffect(() => {
        const fetchRoles = async () => {
            try {

                //console.log("account chnage::::",e);
                const locResponse = await getLocations(1,100,'locationName','asc',{accountKey:editUserData.editUser.accountKey})
                console.log("lcation:::::",locResponse);
                setLocations(locResponse.data);


                setRoles({roles: rolesData.roles, isLoading: true});
                const response = await getRolesByAccount()
                setRoles({roles: response.data, isLoading: false});
            } catch (e) {
                console.log(e);
                setRoles({roles: rolesData.roles, isLoading: false});
            }
        };
        fetchRoles();
    }, []);

  const [user,setUser] =useState({usr:{},isLoading:false});
  
  React.useEffect(() => {
        const fetchUser = async () => {
            try {
                
                const response = await getMyProfile()
                  console.log(response.data[0]);
                  console.log("account=="+response.data[0].accountKey);
                  if (response.data[0].accountKey==="" || response.data[0].role==="Practice Admin")
                  {
                    setUser({usr:response.data[0],isLoading:true});

                  }

                  console.log("user-----"+ user.isLoading);
                 
                
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchUser();
    }, []);

  const [accounts,setAccounts] =useState({account:[]});

  async function  accountChange(e)
 {
      console.log("account chnage::::",e);
      const response = await getLocations(1,100,'locationName','asc',{accountKey:e.target.value})
      console.log("lcation:::::",response);
      setLocations(response.data);
 }
  
  React.useEffect(() => {
        const fetchAccounts = async () => {
            try {
                
                const response = await getAccounts()
                setAccounts({account: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchAccounts();
    }, []);

   /*const [myAccounts,setMyAccounts] =useState({account:[]});
  
  React.useEffect(() => {
        const fetchMyAccounts = async () => {
            try {
                
                const response = await getMyAccounts()
                setMyAccounts({account: response.data});
            } catch (e) {
                console.log(e);
                
            }
        };
        fetchMyAccounts();
    }, []);
*/

/*   React.useFetch(() => {
    getRolesByAccount()
       .then((response) => {
        setRoles(response.data);
        isLoaded=true;
      })
       return () => {
    console.log("This will be logged on unmount");
  }
  }); */
   


  const [statusColor, setStatusColor] = useState('alert-success');

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };



  return (

      <Formik
                  initialValues={{
                    firstName: props.location.data.user.firstName,
                    lastName: props.location.data.user.lastName,
                    email: props.location.data.user.email,
                    mobile: props.location.data.user.mobile,
                    roleKey:props.location.data.user.roleKey,
                    accountKey:props.location.data.user.accountKey,
                    id: props.location.data.user.id,
                    locationKey:props.location.data.user.locationKey,
                    mobileServiceProvider: props.location.data.user.mobileServiceProvider,
                    commPreference: props.location.data.user.commPreference === undefined ? 'both' : props.location.data.user.commPreference,
                  }}
                  validate={values => {
                    const errors = {};

                    if (!values.email) {
                      errors.email = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_FIELD"
                      });
                    }

                    if (!values.firstName) {
                      errors.firstName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.lastName) {
                      errors.lastName = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.mobile) {
                      errors.mobile = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }


                    if (!values.roleKey) {
                      errors.roleKey = intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                                   

                  

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                    enableLoading();
                    editUser(
                      values.id,
                      values.firstName,
                      values.lastName,
                      values.email,
                      values.mobile,
                      values.roleKey,
                      values.accountKey,
                      values.locationKey,
                      'mobileserviceprovider',
                      values.commPreference
                      
                    )
                      .then(resp => {
                        //props.register(accessToken);
                       
                        disableLoading();
                        setStatus(
                          intl.formatMessage({
                            id: "USER.CREATION.SUCCESS.MESSAGE"
                          })
                        );
                        setStatusColor('alert-success');
                        window.scrollTo(0,0);
                       
                      })
                      .catch(() => {
                        disableLoading();
                        setSubmitting(false);
                        setStatus(
                          intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN"
                          })
                        );
                        setStatusColor('alert-danger');
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,

                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      {status && (
                        <div role="alert" className={"alert "+statusColor}>
                          <div className="alert-text">{status}</div>
                        </div>
                      )}

    <CodeExample beforeCodeTitle="Basic Details">
          <div className="kt-section">
            <div className="kt-section__content">



              

                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="roleKey" onBlur={handleBlur} value={values.roleKey}
                        id="roleKey" onChange={handleChange} label="Role"  select>
                        { (user.usr.role === 'Portal Administrator' ||  user.usr.role === 'Practice Admin') &&
                         rolesData.roles.map((rol) => (
                           <MenuItem key={rol.roleId} value={rol.roleId}>{rol.roleDescription}</MenuItem>
                        ))
                        }
                        { user.usr.role !== 'Portal Administrator' && user.usr.role !== 'Practice Admin' &&
                         rolesData.roles.map((rol) => (
                            rol.roleName !== 'PORTALADMIN' && rol.roleName !== 'SASADMIN' && 
                            <MenuItem key={rol.roleId} value={rol.roleId}>{rol.roleDescription}</MenuItem>
                           
                            
                        ))
                        }
                    </TextField>

                     
                            
                      </div>

                      

                     
                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="First Name"
                          className="kt-width-full"
                          name="firstName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.firstName}
                          helperText={touched.firstName && errors.firstName}
                          error={Boolean(touched.firstName && errors.firstName)}
                        />
                      </div>              

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Last Name"
                          className="kt-width-full"
                          name="lastName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.lastName}
                          helperText={touched.lastName && errors.lastName}
                          error={Boolean(touched.lastName && errors.lastName)}
                        />
                      </div>

                      <div className="form-group mb-0">
                        <TextField
                          label="Email"
                          margin="normal"
                          className="kt-width-full"
                          name="email"
                          disabled={true}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.email}
                          helperText={touched.email && errors.email}
                          error={Boolean(touched.email && errors.email)}
                        />
                      </div>

                      <div className="form-group mb-0">
                        <TextField
                          margin="normal"
                          label="Mobile"
                          className="kt-width-full"
                          name="mobile"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.mobile}
                          helperText={touched.mobile && errors.mobile}
                          error={Boolean(
                            touched.mobile && errors.mobile
                          )}
                        />
                      </div>

                      
                      <div className="form-group mb-0">
                        <FormControl component="fieldset">
                          <FormLabel component="legend">Communication Preference</FormLabel>
                          <RadioGroup aria-label="commPreference" name="commPreference" value={values.commPreference} onChange={handleChange} row  >
                            <FormControlLabel value="email" control={<Radio />} label="Email" />
                            <FormControlLabel value="text" control={<Radio />} label="Text" />
                            <FormControlLabel value="both" control={<Radio />} label="Both" />
                            
                          </RadioGroup>
                        </FormControl>
                      </div>

                     

                      <div className="form-group mb-0">
                        {user.isLoading &&
                        <TextField  style={{'width':'100%'}} name="accountKey" onBlur={handleBlur}
                            id="accountKey" onChange={(e) => {handleChange(e);accountChange(e)}} label="Business Entity" helperText={touched.accountKey && errors.accountKey}
                          error={Boolean(
                            touched.accountKey && errors.accountKey
                          )}
                          value={values.accountKey}
                            select>
                            {user.usr.role==="Portal Administrator" &&
                            <MenuItem value="accesstoall">Access to all</MenuItem>
                            }
                            {
                             user.usr.role==="Portal Administrator" && accounts.account.map((acc) => (
                               <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName + ' ('+acc.businessEntity+')'}</MenuItem>
                            
                            ))
                            }

                            {user.usr.role==="Practice Admin" &&
                            
                             accounts.account.map((acc) => (
                               <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName + ' ('+acc.businessEntity+')'}</MenuItem>
                            ))
                            }
                        </TextField>
                      }
                      
                      </div>

                      <div className="form-group mb-0">

                    <TextField  style={{'width':'100%'}} name="locationKey" onBlur={handleBlur}
                        id="locationKey" onChange={handleChange} label="Location"
                        helperText={touched.locationKey && errors.locationKey}
                        value={values.locationKey}
                          error={Boolean(
                            touched.locationKey && errors.locationKey
                          )}
                          select>
                        <MenuItem value="accesstoall">Access to all</MenuItem>
                        { 
                        locations.length>0 && locations.map((loc) => (
                           
                           <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
                            
                        ))
                        }
                    </TextField>

                     
                            
                      </div>


                      

                      
                    
                 
        </div>
        </div>
        </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                              }
                            )}`}
                            style={loadingButtonStyle}
                          >
                           Update
                        </button>
                      </div>
        </form>
         )}
                </Formik>
                
  );
}


export default injectIntl(
  connect(
    null,
    auth.actions
  )(EditUser)
);
